<template>
	<div ref="sticky-element" class="progress-steps mb-4 mb-lg-0">
		<slot />
		<div class="progress-steps__list">
			<div
				v-for="(step, index) in steps"
				:key="index"
				class="progress-steps__item"
				:class="{
					active: step.name === current || index + 1 === current,
					disabled: step.blocked,
					'error-status': error
				}"
				@click="clickHandler(step, index)"
			>
				<div class="progress-steps__circle">
					<span v-if="step.completed" class="icon icon-check-big" />
					<template v-else>
						<span v-if="dynamicIndex">{{ index + 1 }}</span>
						<span v-else>{{ step.id }}</span>
					</template>
				</div>
				<div class="progress-steps__content">
					{{ step.title }}
				</div>
				<!-- Линия соединяющая шаги -->
				<div v-if="index < steps.length - 1" class="progress-steps__line" />
			</div>
		</div>
	</div>
</template>

<script>
import stickyMixin from '~/mixins/stickyMixin';

export default {
	name: 'ProgressSteps',
	mixins: [stickyMixin],
	props: {
		steps: {
			type: Array,
			default: () => [],
		},
		current: {
			type: [Number, String],
			default: 1,
		},
		dynamicIndex: {
			type: Boolean,
			default: false,
		},
		error: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			stickyKit: {
				element: 'sticky-element',
				container: 'sticky-container',
				offset_top: 70,
				from: 768,
			},
		};
	},
	methods: {
		clickHandler(step, index) {
			const data = this.dynamicIndex ? step.name : index + 1;
			this.$emit('change', data);
		},
	},
};

</script>

<style lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

$base-color: #ACB5C7;

.progress-steps {
	width: 100%;
	position: sticky;
	top: 0;

	&__list {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 1.5rem;
		padding: 0;
		margin: 0;

		@include media-breakpoint-down(md) {
			flex-direction: row;
			gap: 1.8rem;
		}
	}

	&__item {
		width: 100%;
		display: flex;
		align-items: center;
		position: relative;
		gap: .5rem;
		cursor: pointer;

		&.active {
			.progress-steps {
				&__circle {
					background-color: $blue;
				}
				&__content {
					display: block;
					color: $blue;
				}
			}

			&.error-status {
				.progress-steps {
					&__circle {
						border: 1px solid $red;
					}

					&__content {
						color: $red;
					}
				}
			}
		}

		&.disabled {
			cursor: default;
			pointer-events: none;
		}

		@include media-breakpoint-down(md) {
			width: auto;
		}
	}

	&__circle {
		width: 1.5rem;
		height: 1.5rem;
		border-radius: 50%;
		background-color: $base-color;
		display: flex;
		align-items: center;
		justify-content: center;
		color: $white;
		font-size: .8rem;
		font-weight: bold;
		transition: background-color 0.3s ease;
	}

	&__content {
		line-height: 1.2rem;
		color: $base-color;

		@include media-breakpoint-down(md) {
			display: none;
			white-space: nowrap;
		}
	}

	&__line {
		position: absolute;
		width: 2px;
		background-color: $base-color;
		height: 1rem;
		left: 10px;
		bottom: -1.3rem;

		@include media-breakpoint-down(md) {
			position: relative;
			bottom: unset;
			transform: rotate(90deg);
		}
	}
}

.btn.btn-primary-outer:hover, .btn.btn-secondary-outer:hover, .btn.btn-secondary:not(.disabled):hover {
	border-color: $border-color !important;
	color: #fff;
}

</style>
